module.exports = __webpack_public_path__ + "static/img/solu4.4f42a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu4.png
// module id = 59Uf
// module chunks = 1